import { Button, Icon } from "armstrong-react";
import React from "react";
import { useState } from "react";
import { Control, LocalForm } from "react-redux-form";
import { Editor, Inline } from "slate";
import { LinkAttributes } from "..";
import { Errors } from "../../../../../../core/atoms/rrf";
import { getNormalisedUrl } from "@travellocal/utils/urlHelpers";
import { updateLink } from "../linkUtils";

/**
 * Test whether a URL can be saved
 */
const validUrl = (value: string) => getNormalisedUrl(value) != null;

interface Props {
  linkNode: Inline;
  controller: Editor;
  onClose: () => void;
}

export const EditLinkForm = ({ linkNode, onClose, controller }: Props) => {

  const [formData, setFormData] = useState<LinkAttributes>({
    href: linkNode.data.get("href"),
    target: linkNode.data.get("target"),
  });

  const onSubmit = (newData: LinkAttributes) => {
    updateLink(controller, { href: getNormalisedUrl(newData.href), target: newData.target });

    // Unselect the link to close the tooltip.
    controller.moveToEndOfNode(linkNode).focus();

    onClose();
  };

  return (
    <LocalForm initialState={formData} onChange={setFormData} onSubmit={onSubmit}>
      <div className="slate-link-tooltip__header">
        <Button
          className="slate-link-tooltip__close"
          onClick={onClose}
          leftIcon={Icon.Icomoon.arrowLeft3}>
          Back
        </Button>

        <Button
          type="submit"
          className="slate-link-tooltip__submit"
          rightIcon={Icon.Icomoon.checkmark3}>
          Save
        </Button>
      </div>

      <div className="slate-link-tooltip__fields">
        <label>
          <span>Link</span>
          <Control.text
            type="text" // Not url - we have our own validation
            model=".href"
            autoFocus
            label="Link"
            validators={{ validUrl }}
          />
          <Errors model=".href" messages={{ validUrl: "Enter a valid URL" }} />
        </label>

        <label>
          <span>Open link in</span>
          <Control.select model=".target" label="Open link in...">
            <option value="_blank">New window</option>
            <option value="_self">Current Window</option>
          </Control.select>
        </label>
      </div>
    </LocalForm>
  );
};
